import * as React from 'react';
import * as classNames from 'classnames';
import {TERMS_URL} from '../../utils/config';
import {Checkbox} from '../checkbox/checkbox';

import {
    consent  as cssConsent,
    checkbox as cssCheckbox,
    link     as cssLink,
} from './terms-consent.module.sass';

interface ITermsConsentProps extends React.InputHTMLAttributes<HTMLInputElement> {
    gdpr?: boolean;
}

export const TermsConsent: React.SFC<ITermsConsentProps> = ({className, gdpr, ...props}) => (
    <div className={classNames(cssConsent, className)}>
        {gdpr && <Checkbox className={cssCheckbox} {...props} />}

        <div>
          {!gdpr && 'By joining, '}
          {'I accept the '}
          <a className={cssLink} target='_blank' href={`${TERMS_URL}#/general`}>
              terms of service
          </a>
          {' and '}
          <a className={cssLink} target='_blank' href={`${TERMS_URL}#/privacy`}>
              privacy policy
          </a>
        </div>
    </div>
);
